import { FC, useState } from 'react';
import { Link } from "react-router-dom";
import "../../styles/layout/footer-menu.scss";

const Menu:FC = () => {
    const [showPrivacyMenu, setShowPrivacyMenu] = useState(false);
    const [showSLAMenu,setShowSLAMenu] = useState(false);
    return (
        <ul className="footer--menu--ul">
            <li>
                {/* <Link to={'/privacy'}>개인정보처리방침</Link> */}
                <b
                    onClick={() => setShowPrivacyMenu((prev: any) => !prev)}
                    style={{ color: "white" }}
                >
                개인정보처리방침
                </b>
                {showPrivacyMenu && (
                <ul className="footer--menu--ul">
                    <li>
                    <Link to="/privacy/all4land">올포랜드</Link>
                    </li>
                    <li>
                    <Link to="/privacy/infoseed">인포씨드</Link>
                    </li>
                    <li>
                    <Link to="/privacy/neospectra">네오스펙트라</Link>
                    </li>
                </ul>
                )}
            </li>
            <li><Link to={'/term'}>이용약관</Link></li>
            <li>
                {/* <Link to={'/sla'}>맵프라임클라우드 서비스 수준 협약</Link> */}
                <b
                    onClick={() => setShowSLAMenu((prev:any) => !prev)}
                    style={{ color: "white" }}
                >
                서비스 수준 협약
                </b>
                {showSLAMenu && (
                <ul className="footer--menu--ul">
                    <li>
                    <Link to="/sla/all4land">올포랜드</Link>
                    </li>
                    <li>
                    <Link to="/sla/infoseed">인포씨드</Link>
                    </li>
                    <li>
                    <Link to="/sla/neospectra">네오스펙트라</Link>
                    </li>
                </ul>
                )}
            </li>
            <li><Link to={'/email'}>이메일주소무단수집거부</Link></li>
        </ul>
    )
}
export default Menu;

